export default __webpack_public_path__ + "102943405e853bda70b7b8d3288c2ad1.ttf";